import React, { FC, useEffect, useState } from 'react';
import AdSense from 'react-adsense';
import { ADSENSE_CLIENT, ADSENSE_SLOT, isAdSenseEnabled } from 'config/ads';

const shellStyle: any = {
  width: '100%',
  maxWidth: 720,
  marginTop: 20,
  marginBottom: 8,
  marginLeft: 'auto',
  marginRight: 'auto',
  paddingTop: 10,
  paddingBottom: 4,
  paddingLeft: 12,
  paddingRight: 12,
  borderTop: '1px solid #ECECEC',
  boxSizing: 'border-box',
};

const labelStyle: any = {
  fontSize: 11,
  lineHeight: '14px',
  letterSpacing: '0.04em',
  textTransform: 'uppercase',
  color: '#A3A3A3',
  marginBottom: 6,
  textAlign: 'center',
  fontFamily: 'system-ui, -apple-system, Segoe UI, sans-serif',
};

const unitStyle: any = {
  display: 'block',
  width: '100%',
  minHeight: 90,
  maxHeight: 100,
  overflow: 'hidden',
};

/**
 * One compact banner at natural pause points (test/part hubs).
 * Delayed mount so practice UI paints first; never used mid-question.
 */
const SubtleAd: FC = () => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!isAdSenseEnabled()) return;
    const timer = setTimeout(() => setReady(true), 900);
    return () => clearTimeout(timer);
  }, []);

  if (!isAdSenseEnabled() || !ready) {
    return null;
  }

  return (
    <div style={shellStyle} aria-label="Sponsored">
      <div style={labelStyle}>Sponsored</div>
      <AdSense.Google
        client={ADSENSE_CLIENT}
        slot={ADSENSE_SLOT}
        style={unitStyle}
        format="horizontal"
        responsive="true"
      />
    </div>
  );
};

export default SubtleAd;
